<template>
  <div class="hide-on-sm hide-on-print">
    <v-row>
      <v-col md="6">
        <v-btn
          block
          depressed
          color="primary"
          @click="search"
        >
          Search
        </v-btn>
      </v-col>
      <v-col md="6">
        <v-btn
          block
          outlined
          depressed
          @click="clear"
        >Clear</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: [
    'isFormValid'
  ],
  methods: {
    search () {
      this.$emit('search')
    },
    clear () {
      this.$emit('clear')
    }
  }
}
</script>
